var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page',[_c('base-container',{class:["action-sheet-page"]},[_c('div',{class:["btn-item"]},[_c('active-sheet')],1),_c('div',{class:["btn-item"]},[_c('sheet')],1),_c('div',{class:["btn-item"]},[_c('picker-sheet')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }